export default __webpack_public_path__ + "static/media/body-bg.f4b63d59.png";